import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgLunchGlyphSecondary from './svgs/LunchGlyphSecondary.js';
import SvgLunchGlyph from './svgs/LunchGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var lunchGlyph = (props => useIcon(SvgLunchGlyph, SvgLunchGlyphSecondary, props));

export { lunchGlyph as default };
